// Fracty lib displays numbers as fractions
import icons from 'url:../../img/icons.svg';
import fracty from 'fracty';

import View from "./View";

class RecipeView extends View {
    _parentElement = document.querySelector('.recipe');

    _errorMessage = `We couldn't find that recipe :( \nPlease, try another one!`;

    _generateMarkup() {
        return `
        <figure class="recipe__fig">
          <img src="${this._data.image}" alt="Recipe photo" class="recipe__img" />
          <h1 class="recipe__title">
            <span>${this._data.title}</span>
          </h1>
        </figure>

        <div class="recipe__details">
          <div class="recipe__info">
            <svg class="recipe__info-icon">
              <use href="${icons}#icon-clock"></use>
            </svg>
            <span class="recipe__info-data recipe__info-data--minutes">${this._data.cookingTime}</span>
            <span class="recipe__info-text">minutes</span>
          </div>
          <div class="recipe__info">
            <svg class="recipe__info-icon">
              <use href="${icons}#icon-users"></use>
            </svg>
            <span class="recipe__info-data recipe__info-data--people">${this._data.servings}</span>
            <span class="recipe__info-text">${this._data.servings !== 1 ? 'servings' : 'serving⠀'}</span>

            <div class="recipe__info-buttons">
              <button data-new-servings="${this._data.servings - 1}" class="btn--tiny btn--update-servings">
                <svg>
                  <use href="${icons}#icon-minus-circle"></use>
                </svg>
              </button>
              <button data-new-servings="${this._data.servings + 1}" class="btn--tiny btn--update-servings">
                <svg>
                  <use href="${icons}#icon-plus-circle"></use>
                </svg>
              </button>
            </div>
          </div>

          <div class="recipe__user-generated ${this._data.key ? '' : 'hidden'}">
           <svg class="">
              <use href="${icons}#icon-user"></use>
            </svg>
          </div>
          <button class="btn--round btn--bookmark">
            <svg class="">
              <use href="${icons}#${this._data.bookmarked ? 'icon-bookmark-fill': 'icon-bookmark'}"></use>
            </svg>
          </button>
        </div>
        <div class="recipe__ingredients">
          <h2 class="heading--2">Recipe ingredients</h2>
          <ul class="recipe__ingredient-list">
          <!--проходимся по всем ингридиентам из API, создаем массив html, соединяем в строку-->
            ${this._data.ingredients.map(this._generateMarkupIngredient).join('')}
          </ul>
        </div>

        <div class="recipe__directions">
          <h2 class="heading--2">How to cook it</h2>
          <p class="recipe__directions-text">
            This recipe was carefully designed and tested by
            <span class="recipe__publisher">${this._data.publisher}</span>. Please check out
            directions at their website.
          </p>
          <a
            class="btn--small recipe__btn"
            href="${this._data.sourceUrl}"
            target="_blank"
          >
            <span>Directions</span>
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-right"></use>
            </svg>
          </a>
        </div>`
    }

    _generateMarkupIngredient(ingredient) {
        return `
            <li class="recipe__ingredient">
                <svg class="recipe__icon">
                    <use href="${icons}#icon-check"></use>
                </svg>
                    <div class="recipe__quantity">
                        ${ingredient.quantity ? fracty(ingredient.quantity) : ''}
                    </div>
                    <div class="recipe__description">
                        <span class="recipe__unit">${ingredient.unit}</span> ${ingredient.description}
                    </div>
            </li>`

    };

    // Publisher в pub-sub. Добавляет callback для начала рендеринга при возникновении событий
    addHandlerRender(handler) {
        ['hashchange', 'load'].forEach(event => window.addEventListener(event, handler));
    }

    addHandlerUpdateServings(handler) {
        this._parentElement.addEventListener('click', (e) => {
            const btn = e.target.closest('.btn--update-servings');
            if (!btn) return;

            const newServings = +btn.dataset.newServings;

            if (newServings > 0)
                handler(newServings);
        });
    }

    addHandlerBookmark(handler) {
        this._parentElement.addEventListener('click', (e) => {
            const btn = e.target.closest('.btn--bookmark');
            if (!btn) return;
            handler();
        });
    }
}

export default new RecipeView();